import styles from './VoucherCode.module.scss';
import React from 'react';
import { getTranslation } from '../../../../../utils/translation';

const VoucherCode = props => {
    const { voucherCode, onChange } = props;
    return (
        <input
            type='text'
            className={styles.input}
            placeholder={getTranslation('voucherCodeInputPlaceholder')}
            value={voucherCode}
            onChange={onChange}
        />
    );
};

export default VoucherCode;
